import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Loading } from '../components/Loading';
import { useApiRepo, Endpoints } from '../utils/Api';
import { Colors } from '../utils/Colors';
import { ProviderInfo } from '../utils/ProviderInfoContext';

export function ConfirmInvite() {
  const navigate = useNavigate();
  const { getObjectsFromAPI } = useApiRepo();
  const [cookies, , removeCookie] = useCookies(['inviteId']);
  const [isLoading, setIsLoading] = useState(true);
  const [providerInfo, setProviderInfo] = useState<ProviderInfo>();

  const rejectInvite = async () => {
    // clear cookie
    removeCookie('inviteId', { path: '/' });

    navigate('/');
  };

  const claimInvite = async () => {
    // claim patient record
    const api = await getObjectsFromAPI();

    try {
      await api.post(`${Endpoints.claimPatientInvite}/${cookies.inviteId}`);

      removeCookie('inviteId', { path: '/' });

      navigate('/profile');
    } catch (err) {
      if (axios.isAxiosError(err) && err?.response?.status === 404) {
        // no invite, delete cookie
        removeCookie('inviteId', { path: '/' });
      }
    }
  };

  useEffect(() => {
    const fetchProviderInfo = async () => {
      if (cookies.inviteId) {
        const api = await getObjectsFromAPI();

        try {
          const pi = await api.get(
            `${Endpoints.getPatientProviderInfoByInvite}/${cookies.inviteId}`
          );
          setProviderInfo(pi.data.data);
        } catch (err) {
          if (axios.isAxiosError(err) && err?.response?.status === 404) {
            // no invite, delete cookie
            removeCookie('inviteId', { path: '/' });

            // send back to home
            navigate('/');
          }

          throw err;
        }

        setIsLoading(false);
      } else {
        // no inviteId cookie, send to home
        navigate('/');
      }
    };

    fetchProviderInfo();
  }, [cookies.inviteId]);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Grid
      container
      spacing={2}
      direction="row"
      style={{ padding: '50px 0', width: '90vw', margin: 'auto' }}
    >
      <Grid item xs={12}>
        <Typography align="left" style={{ fontSize: '36px' }}>
          Share data with {providerInfo?.organization?.name}?
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography align="left" style={{ fontSize: '18px' }}>
          {providerInfo?.organization?.name} has invited you to join their
          platform, where you can effectively manage your OCD with the guidance
          and support of your therapist. By accepting this invitation, you are
          allowing your therapist to securely access your data, ensuring
          personalized and tailored treatment to help you on your journey to
          wellness.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button
          color="inherit"
          style={{
            padding: '5px 20px',
            color: '#010d0d',
            borderRadius: 30,
            fontSize: '20px',
            backgroundColor: Colors.ocdGreen
          }}
          onClick={claimInvite}
        >
          Accept
        </Button>
        <Button
          color="inherit"
          style={{
            padding: '5px 20px',
            color: '#010d0d',
            borderRadius: 30,
            fontSize: '20px'
          }}
          onClick={rejectInvite}
        >
          Reject
        </Button>
      </Grid>
    </Grid>
  );
}
